import AddUserPopUpView from './AddUserPopUp.view';
export * from './AddUserPopUp.view';

export const AddUserPopUp = (props) => AddUserPopUpView(props);

export default AddUserPopUp;

